export const AUTH_KEY = "oaTag"
export const PROMO_CODE_KEY = "promoCode"
export const AUTH_REDIRECT_URL_KEY = "authSuccessUrl"
export const TEMP_SESSION_KEY = "tmp_tag"

export const BEHAVIOUR_TYPE = {
  purchase: "PURCHASE",
  notification: "NOTIFICATION"
}

export const STEPS = {
  zone: "select-zone",
  date: "select-date",
  rate: "select-rate"
}

export const RATE_AVAILABILITY_COLORS = {
  soldOut: "#F7CDD4",
  available: "#31C81933",
  unavailable: "#f0f0f0"
}

export const MESSAGE_CARD_TYPES = {
  soldOut: "soldout",
  notification: "notification",
  unavailable: "unavailable"
}

export const MANDATORY_FIELDS = {
  firstName: "firstName",
  lastName: "lastName",
  phoneNumber: "phoneNumber",
  regionCode: "regionCode"
}

export const EXISTING_PHONE_NUMBER_TEXT = {
  heading: "Update Phone Number",
  description:
    "The phone number on file has been linked to another account. To continue on this account, please add and verify a new phone number.",
  continueButton: "Update Phone Number"
}

export const MULTIPLE_ACCOUNTS_FOUND_TEXT = {
  heading: "Multiple Accounts Found",
  description:
    "This phone number is linked to one or more accounts. Verifying this account will remove it from other accounts. Do you want to continue?",
  yesButton: "Yes, Verify Account",
  noButton: "No, Return to Login",
  disclaimer: "If you have multiple accounts, please contact Customer Support."
}

export const ACCESS_RESTRICTED_TEXT = {
  heading: "Access Restricted",
  description:
    "You're not permitted to access this parking location. If you believe this is a mistake, please contact our support team for assistance.",
  contactButton: "Contact Support"
}

export const REDIRECT_TO_HONK_TEXT = {
  title: "Redirecting to HONK",
  message: "Redirecting to HONK",
  copy: "Continue your parking reservation with HonkMobile"
}

export const REDIRECT_TO_CONTACT_US_TEXT = {
  title: "Redirecting to HONK support.",
  message: "Redirecting to HONK support.",
  copy: "Please fill out the following form so our team can help you."
}

export const SMS_SUCCESS_TEXT = {
  heading: "Account Verified",
  description: "You're all set! Let's find you a parking spot.",
  homeButton: "Go to Home"
}

export const ACCOUNT_PROFILE_MODAL_TYPE = {
  mandatoryFields: "mandatoryFields",
  settings: "settings"
}
